if ($('.header_transparent').length > 0) {
  const body = $('body');
  const triggerScroll = 100;

  $(window).on('scroll load', function() {
    let currentTop = $(this).scrollTop();

    currentTop > triggerScroll ? body.removeClass('header_transparent') : body.addClass('header_transparent');
  });
}